import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Modal } from 'react-bootstrap';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import { useNavigate, Link } from 'react-router-dom';
import { FaCaretRight, FaCaretDown, FaTimes, FaPlus, FaPaperPlane, FaSave, FaUserShield, FaArrowCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import styled from 'styled-components';
import Commentaire from './commentaire';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';



const Eligibilite = ({ index }) => {
    useAuth(); // Authentication required
    const navigate = useNavigate();
    const wordCounts = JSON.parse(localStorage.getItem('wordCounts')) || {};

    const user_id = localStorage.getItem('user_id');
    const lieu = "ATP INOVACT";
    const titre = "PMP Preparation Course";

    const [userData, setUserData] = useState({
        email: '',
        nom: '',
        prenoms: '',
        tel: '',
    });



    const [isLoading, setIsLoading] = useState(true); // État pour gérer le chargement pendant la déconnexion
    const [showKeywordModal, setShowKeywordModal] = useState(false);
    const [selectedKeyword, setSelectedKeyword] = useState(null); // Mot-clé sélectionné
    const [modalContent, setModalContent] = useState("keywords"); // Contrôle du contenu du modal (mots-clés ou sous-mots)

    // Calcule la date limite (aujourd'hui - 10 ans) au format YYYY-MM-DD
    const getMinDate = () => {
        const d = new Date();
        d.setFullYear(d.getFullYear() - 10);
        return d.toISOString().split('T')[0];
    };

    const [isAnalysing, setIsAnalysing] = useState(false);
    const [chatGPTAnalysis, setChatGPTAnalysis] = useState('');
    const [showAnalysisModal, setShowAnalysisModal] = useState(false);

    const handleChatGPTAnalysis = async (description, projectContext = {}) => {
        if (!description.trim()) {
            showAlert('La description est vide. Veuillez d\'abord saisir un texte.', 'warning');
            return;
        }

        setIsAnalysing(true);
        setChatGPTAnalysis(''); // Réinitialiser l'analyse précédente

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/analyse-description-chatgpt/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    description: description,
                    context: `Projet: ${projectContext.titre || 'Sans titre'} - Rôle: ${projectContext.poste_occupe || 'Non spécifié'}`
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setChatGPTAnalysis(data.analysis);
                setShowAnalysisModal(true); // Ouvrir le modal pour afficher l'analyse
            } else {
                console.error('Erreur du serveur:', data);
                showAlert(`Erreur lors de l'analyse : ${data.error || 'Erreur inconnue'}`, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur.', 'danger');
        } finally {
            setIsAnalysing(false);
        }
    };




    const [deepSeekAnalysis, setDeepSeekAnalysis] = useState('');
    const handleDeepSeekAnalysis = async (description, projectContext = {}) => {
        if (!description.trim()) {
            showAlert('La description est vide. Veuillez d\'abord saisir un texte.', 'warning');
            return;
        }

        setIsAnalysing(true);
        setDeepSeekAnalysis(''); // Renommer cette variable

        try {
            // Changer l'endpoint
            const response = await fetch(`${process.env.REACT_APP_HOTE}/analyse-description-deepseek/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    description: description,
                    context: `Projet: ${projectContext.titre || 'Sans titre'} - Rôle: ${projectContext.poste_occupe || 'Non spécifié'}`
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setDeepSeekAnalysis(data.analysis);
                setShowAnalysisModal(true);
            } else {
                console.error('Erreur du serveur:', data);
                showAlert(`Erreur lors de l'analyse : ${data.error || 'Erreur inconnue'}`, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur DeepSeek.', 'danger');
        } finally {
            setIsAnalysing(false);
        }
    };

    // Liste des mots-clés avec leurs sous-mots associés

    const keywordData = {
        "Initiating": [
            "Conduct project selection methods",
            "Develop the project charter",
            "Identify key stakeholders",
            "Define the scope of the project",
            "Evaluate the feasibility of new products or services",
            "Review the charter with key stakeholders to confirm project scope, risks, issues, assumptions and constraints",
            "Identify and document high level risks, assumptions and constraints"
        ],
        "Planning": [
            "Gather and document requirements",
            "Identify key project team members",
            "Define roles and responsibilities",
            "Create the work breakdown structure",
            "Develop a communication plan",
            "Develop the cost, schedule, resource, quality and procurement plans",
            "Decompose tasks",
            "Divide and prioritize tasks",
            "Develop project schedules",
            "Estimate costs",
            "Allocate budget",
            "Identify and document project risks",
            "Evaluate project risks",
            "Define risk strategies",
            "Develop contingency plans",
            "Develop the risk management plan",
            "Meet vendors",
            "Product evaluations",
            "Prepare RFPs, RFQs",
            "Conduct a kick off meeting",
            "Develop the change management plan"
        ],
        "Executing": [
            "Manage the resource allocation",
            "Execute tasks defined in the project plan",
            "Implement a quality management plan",
            "Implement approved changes",
            "Gather, maintain, and approve timesheets",
            "Provide coaching and training to team members",
            "Implement approved actions and workarounds",
            "Obtain project resources",
            "Conduct team building activities",
            "Evaluate resumes",
            "Interview candidates",
            "Take corrective actions"
        ],
        "Monitoring & Controlling": [
            "Report performance",
            "Compile change requests",
            "Perform quality control audits",
            "Perform earned value analysis",
            "Track schedule, cost, quality, risk, etc.",
            "Monitor the status of identified risks",
            "Verify the scope of the project",
            "Ensure the project deliverables conform to quality standards established in the project quality plan",
            "Identify any new risks",
            "Update the risk response plan"
        ],
        "Closing": [
            "Obtain final acceptance for the project",
            "Identify and document lessons learned",
            "Update project records and documents",
            "Archive project records and documents",
            "Obtain financial, legal and administrative project closure",
            "Release project resources and provide performance feedback",
            "Create and distribute final project report",
            "Measure customer satisfaction"
        ]
    };

    // Fonction pour gérer l'ouverture/fermeture du modal
    const handleShowKeywordModal = () => {
        setModalContent("keywords"); // Par défaut, afficher les mots-clés
        setShowKeywordModal(true);
    };
    const handleCloseKeywordModal = () => setShowKeywordModal(false);

    // Fonction appelée lorsqu'un mot-clé est cliqué, pour afficher ses sous-mots
    const handleKeywordClick = (keyword) => {
        setSelectedKeyword(keyword);
        setModalContent("subwords"); // Passer à l'affichage des sous-mots
    };

    // Insérer un sous-mot dans la description
    const insertWord = (index, word) => {
        const newFormDataList = [...formDataList];
        newFormDataList[index].description += ` ${word}`;
        setFormDataList(newFormDataList);
        handleCloseKeywordModal(); // Fermer le modal après insertion
    };


    const [errorList, setErrorList] = useState([]);
    const [expanded, setExpanded] = useState([true]);
    // const [expanded, setExpanded] = useState(formDataList.map(() => false)); // Initialement, tous les projets sont fermés
    const [validationMois, setValidationMois] = useState('');
    const [totalMonths, setTotalMonths] = useState(0); // État pour stocker le total des mois
    const [monthsForProjects, setMonthsForProjects] = useState([]); // État pour stocker les mois par projets
    const [datesForProjects, setDatesForProjects] = useState([]); // État pour stocker les dates par projets
    const [canAddProject, setCanAddProject] = useState(true); // Gérer la possibilité d'ajouter un projet
    const maxWordCount = 500; // Limite de mots
    const [wordForProjects, setWordForProjects] = useState([]); // État pour stocker les mois par projets


    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Eligibilite"; // Définit le titre de la page
        }
    }, [user_id]);

    // État pour stocker l'ID du formulaire
    const [formulaire_id, setFormulaireId] = useState(null);
    // Etat pour stocker les données charger de la base de données
    const [dataEligibilite, setDataEligibilite] = useState();
    // Etat pour stocker les données charger de la base de données
    const [compterPremierEnregistrement, setCompterPremierEnregistrement] = useState(false);
    //Stocker les erreurs
    const [cumulativeError, setCumulativeError] = useState('');
    const [etapeComplete, setEtapeComplete] = useState(1);


    const [statut, setStatut] = useState("");

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                // setIsLoading(true); // Activer le loader avant de commencer le chargement des données

                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                    method: 'get',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        const fetchIdData = async () => {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-eligibilite-pour-admin/${user_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-pour-admin/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                console.log('Données du formulaire récupérées Id:', data);

                // Récupérer l'ID du formulaire à partir des données
                if (data.id) {
                    setFormulaireId(data.id);
                }

                // Vérifier le statut
                // Vérifier le statut et ajuster le currentStep
                if (data.statut) {
                    setStatut(data.statut); // Mettre à jour le statut
                    if (data.statut === "valide") {
                        setCurrentStep(5); // Fixer l'utilisateur à la page 5
                    }
                }
                // setDataEligibilite(data);
            } catch (error) {
                console.error("L'utilisateur n'a probablement pas de formulaire enregistré:", error);
            }
        };

        const fetchFormData = async () => {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-eligibilite-utilisateur/${user_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-utilisateur/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                console.log('Données du formulaire récupérées modif:', data);

                // Récupérer l'ID du formulaire à partir des données
                setFormData(data);
                setFormDataList(data.experiences);
                // setDataEligibilite(data);
            } catch (error) {
                console.error("L'utilisateur n'a probablement pas de modification enregistré:", error);
                // const formRecupString = localStorage.getItem('formData');
                // const formRecup = formRecupString ? JSON.parse(formRecupString) : {};
                // console.log('sisi:', formRecup);
                // setFormData(formRecup);
            } finally {
                setIsLoading(false); // Désactiver le loader après la récupération des données
            }
        };

        fetchUserData();
        fetchIdData();
        fetchFormData();
    }, [user_id]);

    const [formData, setFormData] = useState({
        niveau_eleve: "",
        annee_debut_education: "",
        annee_fin_education: "",
        pays: "",
        institution: "",
        filiere: "",
        lieu_formation: "ATP INOVACT",  // Default value for lieu_formation
        titre_cours: "PMP Preparation Course",  // Default value for titre_cours
        date_debut_cours: "",
        date_fin_cours: "",
        nombre_heures: ""
    });
    const [formDataList, setFormDataList] = useState([{
        // id: '',
        titre_projet: '',
        organisation: '',
        poste_occupe: '',
        domaine_fonctionnel: '',
        objectif_organisation: '',
        approche_methodologique: '',
        taille_equipe: '',
        budget: '',
        date_debut_projet: '',
        date_fin_projet: '',
        description: '',
    }]);

    // Calculer la durée en mois entre deux dates
    const calculateMonths = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    };
    // Vérification du total des mois
    useEffect(() => {
        let total = 0;
        const monthsList = [];
        const nbreMotsList = [];
        const datesList = [];
        formDataList.forEach((formData) => {
            if (formData.date_debut_projet && formData.date_fin_projet) {
                total += calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
                const months = calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
                monthsList.push(months); // Ajoute la durée de ce projet en mois dans monthsList

                // Formater les dates avant de les ajouter à la liste
                const formatDate = (dateString) => {
                    const date = new Date(dateString);
                    if (!isNaN(date)) {
                        const day = date.getDate().toString().padStart(2, '0');
                        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois sont indexés à partir de 0
                        const year = date.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                    return dateString; // Retourne la date initiale en cas d'erreur
                };

                datesList.push(
                    `${formatDate(formData.date_debut_projet)} - ${formatDate(formData.date_fin_projet)}`
                );
            }

            if (formData.description) {
                const wordsArray = formData.description.trim().split(/\s+/);
                const wordCount = wordsArray.filter(word => word.length > 0).length;
                nbreMotsList.push(wordCount);
            }
        });

        setTotalMonths(total);
        setMonthsForProjects(monthsList);
        setDatesForProjects(datesList);
        setWordForProjects(nbreMotsList);



        // Nouvelle vérification en fonction du niveau d'éducation
        if (["BAC", "BTS", "Licence"].includes(formData.niveau_eleve)) {
            // Niveau inférieur à Master1 -> minimum de 60 mois requis
            setCanAddProject(total < 60);
        } else {
            // Niveau supérieur ou égal à Master1 -> minimum de 36 mois requis
            setCanAddProject(total < 36);
        }
    }, [formDataList, formData.niveau_eleve]);


    // useEffect(() => {
    //     const fetchExistingData = async () => {
    //         try {
    //             console.log("Fetching data for user_id:", user_id);

    //             const response = await fetch(process.env.REACT_APP_HOTE + `/charger-eligibilite/${user_id}/`);
    //             if (!response.ok) {
    //                 throw new Error("Erreur lors de la récupération des données.");
    //             }

    //             const existingData = await response.json();
    //             console.log('Données existantes récupérées you:', existingData);

    //             // Mise à jour de formData avec les données récupérées
    //             setFormData(existingData);

    //             // Vérifie si des expériences existent dans les données récupérées
    //             if (existingData.experiences && existingData.experiences.length > 0) {
    //                 console.log("Des expériences ont été trouvées :", existingData.experiences);
    //                 setFormDataList(existingData.experiences);
    //             } else {
    //                 console.log("Aucune expérience trouvée, formulaire vide initialisé");
    //                 setFormDataList([{
    //                     // id: '',
    //                     titre_projet: '',
    //                     organisation: '',
    //                     poste_occupe: '',
    //                     domaine_fonctionnel: '',
    //                     objectif_organisation: '',
    //                     approche_methodologique: '',
    //                     taille_equipe: '',
    //                     budget: '',
    //                     date_debut_projet: '',
    //                     date_fin_projet: '',
    //                     description: '',
    //                 }]);
    //             }
    //         } catch (error) {
    //             console.error('Erreur lors de la récupération des données du formulaire:', error);
    //         } finally {
    //             setIsLoading(false); // Désactiver le loader après la récupération des données
    //         }
    //     };

    //     fetchExistingData();
    // }, [user_id]);


    // Gestion de l'étape actuelle
    const [currentStep, setCurrentStep] = useState(1);

    const retourStep = () => {
        if (currentStep === 2) {
            // Étape 2 - Validation Éducation Académique
            const { annee_debut_education, annee_fin_education } = formData;
            if (formData.niveau_eleve && formData.annee_debut_education && formData.annee_fin_education && formData.pays && formData.institution && formData.filiere) {
                if (etapeComplete < 2) setEtapeComplete(2)
            }
            if (parseInt(annee_debut_education) <= parseInt(annee_fin_education)) {
                if (etapeComplete < 2) setEtapeComplete(2)
            }
        } else if (currentStep === 3) {
            // Étape 3 - Validation Formation Professionnelle
            const { date_debut_cours, date_fin_cours } = formData;
            if (formData.lieu_formation && formData.titre_cours && formData.date_debut_cours && formData.date_fin_cours && formData.nombre_heures) {
                if (etapeComplete < 3) setEtapeComplete(3)
            }
            if (new Date(date_debut_cours) <= new Date(date_fin_cours)) {
                if (etapeComplete < 3) setEtapeComplete(3)
            }
            if (parseInt(formData.nombre_heures, 10) >= 35) {
                if (etapeComplete < 3) setEtapeComplete(3)
            }
        } else if (currentStep === 4) {
            // Étape 4 - Validation Experience Projet
            formDataList.forEach((formData, index) => {
                if (Object.values(formData).some(field => field !== "")) {
                    if (etapeComplete < 4) setEtapeComplete(4)
                }
            });
        } else if (currentStep === 5) {
            if (etapeComplete < 5) setEtapeComplete(5)
        }
        setCumulativeError('');
        return true;
    };

    // // Fonction de validation pour les champs obligatoires
    // const validateStep = () => {
    //     if (currentStep === 2) {
    //         // Étape 2 - Validation Éducation Académique
    //         const { annee_debut_education, annee_fin_education } = formData;
    //         if (!formData.niveau_eleve || !formData.annee_debut_education || !formData.annee_fin_education || !formData.pays || !formData.institution || !formData.filiere) {
    //             setCumulativeError('Veuillez remplir tous les champs obligatoires de cette étape.');
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //         const niveauxAutorises = ["BAC", "BTS", "Licence", "Master1", "Master2", "Doctorat", "Ingénieur", "Autres"];
    //         if (!niveauxAutorises.includes(formData.niveau_eleve)) {
    //             setCumulativeError("Veuillez choisir le Niveau élevé d'éducation qui vous correspond");
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //         if (parseInt(annee_debut_education) >= parseInt(annee_fin_education)) {
    //             setCumulativeError('L\'année de début doit être antérieure à l\'année de fin.');
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //     } else if (currentStep === 3) {
    //         // Étape 3 - Validation Formation Professionnelle
    //         const { date_debut_cours, date_fin_cours } = formData;
    //         if (!formData.date_debut_cours || !formData.date_fin_cours || !formData.nombre_heures) {
    //             setCumulativeError('Veuillez remplir tous les champs obligatoires de cette étape.');
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //         if (new Date(date_debut_cours) >= new Date(date_fin_cours)) {
    //             setCumulativeError('La date de début doit être antérieure à la date de fin.');
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //         if (parseInt(formData.nombre_heures, 10) < 35) {
    //             setCumulativeError("Le nombre total d'heures doit être au minimum 35h.");
    //             window.scrollTo(0, 0);
    //             return false;
    //         }
    //     } else if (currentStep === 4) {
    //         const { niveau_eleve } = formData;
    //         const newErrorList = [...errorList];
    //         let valid = true;
    //         const areDatesOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
    //             return (startDate1 <= endDate2 && startDate2 <= endDate1);
    //         };
    //         let hasOverlappingProjects = false;
    //         let overlappingProjects = []; // Tableau pour stocker les projets qui se chevauchent
    //         // const newExpanded = [...expanded]; // Copier l'état des projets ouverts/fermés

    //         // Validation pour chaque projet dans formDataList
    //         formDataList.forEach((formData, index) => {
    //             const wordCount = formData.description.split(' ').length;

    //             // Vérification du nombre de mots
    //             if (wordCount < 200 || wordCount > 500) {
    //                 newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
    //                 valid = false;
    //             } else {
    //                 setErrorList([...newErrorList, '']);
    //             }

    //             // Vérification des dates de projet
    //             const startDate = new Date(formData.date_debut_projet);
    //             const endDate = new Date(formData.date_fin_projet);
    //             if (endDate <= startDate) {
    //                 newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
    //                 valid = false;
    //             }

    //             // Vérification des chevauchements avec les autres projets

    //             formDataList.forEach((otherFormData, otherIndex) => {
    //                 if (index !== otherIndex) {
    //                     const otherStartDate = new Date(otherFormData.date_debut_projet);
    //                     const otherEndDate = new Date(otherFormData.date_fin_projet);

    //                     if (areDatesOverlapping(startDate, endDate, otherStartDate, otherEndDate)) {
    //                         newErrorList[index] = `Les dates de ce projet chevauchent celles du projet "${otherFormData.titre_projet}".`;
    //                         valid = false;
    //                         hasOverlappingProjects = true;

    //                         // Ajouter le nom des deux projets dans le tableau des projets en conflit
    //                         overlappingProjects.push({
    //                             projet1: formData.titre_projet,
    //                             projet2: otherFormData.titre_projet,
    //                         });
    //                     }
    //                 }
    //             });

    //             // Vérification des champs vides
    //             if (Object.values(formData).some(field => field === "")) {
    //                 newErrorList[index] = 'Tous les champs doivent être remplis...';
    //                 valid = false;
    //                 return; // Sortie de la boucle
    //             }
    //         });

    //         if (hasOverlappingProjects) {
    //             // Message d'erreur global avec les projets en conflit
    //             const overlappingMessage = overlappingProjects.map(
    //                 proj => `Le projet "${proj.projet1}" chevauche le projet "${proj.projet2}".`
    //             ).join(' ');

    //             setCumulativeError(`Les dates de certains projets se chevauchent. Détails : ${overlappingMessage}`);
    //             valid = false;
    //         }

    //         // Définir le seuil de mois minimum en fonction du niveau d'éducation
    //         const minimumMonthsRequired = ['Master1', 'Master2', 'Doctorat', 'Ingénieur', 'Licence', 'Autres'].includes(niveau_eleve) ? 36 : 60;

    //         // Vérification du total des mois d'expérience en fonction du niveau
    //         if (totalMonths < minimumMonthsRequired) {
    //             setValidationMois('');
    //             setCumulativeError(`Le total des mois d'expérience doit être d'au moins ${minimumMonthsRequired} mois. Vous avez actuellement déclaré ${totalMonths}/${minimumMonthsRequired} mois. Il vous en reste ${minimumMonthsRequired - totalMonths} à déclarer. Veuillez ajouter un autre projet pour atteindre les ${minimumMonthsRequired} mois requis ou remplacer le(s) projet(s) existants par un(des) projet(s) de plus longue durée.`);  // Affiche le message d'erreur global`);
    //             valid = false;  // Bloquer l'envoi si la condition n'est pas remplie
    //         } else {
    //             const hasExceedingProjects = formDataList.some((formData) => {
    //                 const months = calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
    //                 return months >= minimumMonthsRequired && formDataList.length > 1;
    //             });

    //             if (hasExceedingProjects) {
    //                 setCumulativeError(`L'un de vos projets atteint déjà les ${minimumMonthsRequired} mois de durée requis. Vous ne pouvez pas soumettre un autre projet de plus.`);
    //                 valid = false;
    //             } else {
    //                 setCumulativeError(''); // Pas d'erreur si tout est correct
    //             }
    //         }
    //         setErrorList(newErrorList);

    //         // if (!valid) {
    //         //     window.scrollTo(0, 0); // Défilement en haut de la page en cas d'erreur
    //         //     return false; // Ne pas continuer si le formulaire n'est pas valide
    //         // } 
    //         if (!valid) {
    //             // Si une erreur est associée à un projet spécifique
    //             const firstErrorIndex = newErrorList.findIndex(error => error !== ''); // Trouver le premier projet avec une erreur

    //             if (firstErrorIndex !== -1) {
    //                 const projectElement = document.getElementById(`project-${firstErrorIndex}`);
    //                 if (projectElement) {
    //                     // Faire défiler jusqu'au projet
    //                     projectElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //                 }

    //             setExpanded([...expanded, true]);

    //             } else {
    //                 // Si l'erreur est globale, défiler en haut
    //                 window.scrollTo(0, 0);
    //             }

    //             return false; // Ne pas continuer si le formulaire n'est pas valide
    //         }

    //     }
    //     SauvegarderDeSuivant();
    //     setCumulativeError(''); // Si aucune erreur, on vide le message d'erreur
    //     // setErrorList([...newErrorList, '']);
    //     window.scrollTo(0, 0);
    //     return true;
    // };

    const validateStep = () => {
        if (currentStep === 2) {
            // Étape 2 - Validation Éducation Académique
            const { annee_debut_education, annee_fin_education } = formData;
            if (!formData.niveau_eleve || !formData.annee_debut_education || !formData.annee_fin_education || !formData.pays || !formData.institution || !formData.filiere) {
                setCumulativeError('Veuillez remplir tous les champs obligatoires de cette étape.');
                window.scrollTo(0, 0);
                return false;
            }
            const niveauxAutorises = ["BAC", "BTS", "Licence", "Master1", "Master2", "Doctorat", "Ingénieur", "Autres"];
            if (!niveauxAutorises.includes(formData.niveau_eleve)) {
                setCumulativeError("Veuillez choisir le Niveau élevé d'éducation qui vous correspond");
                window.scrollTo(0, 0);
                return false;
            }
            if (parseInt(annee_debut_education) >= parseInt(annee_fin_education)) {
                setCumulativeError('L\'année de début doit être antérieure à l\'année de fin.');
                window.scrollTo(0, 0);
                return false;
            }
        } else if (currentStep === 3) {
            // Étape 3 - Validation Formation Professionnelle
            const { date_debut_cours, date_fin_cours } = formData;
            if (!formData.date_debut_cours || !formData.date_fin_cours || !formData.nombre_heures) {
                setCumulativeError('Veuillez remplir tous les champs obligatoires de cette étape.');
                window.scrollTo(0, 0);
                return false;
            }
            if (new Date(date_debut_cours) >= new Date(date_fin_cours)) {
                setCumulativeError('La date de début doit être antérieure à la date de fin.');
                window.scrollTo(0, 0);
                return false;
            }
            if (parseInt(formData.nombre_heures, 10) < 35) {
                setCumulativeError("Le nombre total d'heures doit être au minimum 35h.");
                window.scrollTo(0, 0);
                return false;
            }
        }
        else if (currentStep === 4) {
            const { niveau_eleve } = formData;
            const newErrorList = [...errorList];
            let valid = true;
            const areDatesOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
                return (startDate1 <= endDate2 && startDate2 <= endDate1);
            };
            let hasOverlappingProjects = false;
            let overlappingProjects = []; // Tableau pour stocker les projets en conflit

            const newExpanded = [...expanded]; // Copier l'état des projets ouverts/fermés

            formDataList.forEach((formData, index) => {
                // const wordCount = formData.description.split(' ').length;
                const wordCount = formData.description.trim().split(/\s+/).length;

                // Vérification du nombre de mots
                if (wordCount < 200 || wordCount > 500) {
                    newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
                    valid = false;
                    newExpanded[index] = true; // Ouvrir ce projet
                } else {
                    newErrorList[index] = ''; // Pas d'erreur pour ce champ
                }

                // // Vérification du nombre de mots
                // if (wordForProjects < 200 || wordForProjects > 500) {
                //     newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
                //     valid = false;
                //     newExpanded[index] = true; // Ouvrir ce projet
                // } else {
                //     newErrorList[index] = ''; // Pas d'erreur pour ce champ
                // }

                // Vérification des dates de projet
                const startDate = new Date(formData.date_debut_projet);
                const endDate = new Date(formData.date_fin_projet);
                if (endDate <= startDate) {
                    newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
                    valid = false;
                    newExpanded[index] = true; // Ouvrir ce projet
                }

                // Vérification des chevauchements
                formDataList.forEach((otherFormData, otherIndex) => {
                    if (index !== otherIndex) {
                        const otherStartDate = new Date(otherFormData.date_debut_projet);
                        const otherEndDate = new Date(otherFormData.date_fin_projet);

                        if (areDatesOverlapping(startDate, endDate, otherStartDate, otherEndDate)) {
                            newErrorList[index] = `Les dates de ce projet chevauchent celles du projet "${otherFormData.titre_projet}".`;
                            valid = false;
                            hasOverlappingProjects = true;
                            newExpanded[index] = true; // Ouvrir ce projet
                            overlappingProjects.push({
                                projet1: formData.titre_projet,
                                projet2: otherFormData.titre_projet,
                            });
                        }
                    }
                });

                // Vérification des champs vides
                if (Object.values(formData).some(field => field === "")) {
                    newErrorList[index] = 'Tous les champs doivent être remplis.';
                    valid = false;
                    newExpanded[index] = true; // Ouvrir ce projet
                }
            });

            if (hasOverlappingProjects) {
                const overlappingMessage = overlappingProjects.map(
                    proj => `Le projet "${proj.projet1}" chevauche le projet "${proj.projet2}".`
                ).join(' ');

                setCumulativeError(`Les dates de certains projets se chevauchent. Détails : ${overlappingMessage}`);
                valid = false;
            }

            const minimumMonthsRequired = ['Master1', 'Master2', 'Doctorat', 'Ingénieur', 'Licence', 'Autres'].includes(niveau_eleve) ? 36 : 60;
            if (totalMonths < minimumMonthsRequired) {
                setCumulativeError(`Le total des mois d'expérience doit être d'au moins ${minimumMonthsRequired} mois. Vous avez actuellement déclaré ${totalMonths}/${minimumMonthsRequired} mois. Il vous reste ${minimumMonthsRequired - totalMonths} mois à compléter.`);
                valid = false;
            }

            setErrorList(newErrorList);
            setExpanded(newExpanded); // Mettre à jour l'état des projets ouverts/fermés

            if (!valid) {
                const firstErrorIndex = newErrorList.findIndex(error => error !== '');
                if (firstErrorIndex !== -1) {
                    const projectElement = document.getElementById(`project-${firstErrorIndex}`);
                    if (projectElement) {
                        projectElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else {
                    window.scrollTo(0, 0);
                }
                return false;
            }
        }

        SauvegarderDeSuivant();
        setCumulativeError('');
        setErrorList(['']);
        window.scrollTo(0, 0);
        return true;
    };


    // Fonction pour aller à l'étape suivante
    const nextStep = () => {
        if (validateStep()) {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    };

    // Fonction pour revenir à l'étape précédente
    const prevStep = () => {
        setCurrentStep((prevStep) => prevStep - 1);
        retourStep()
    };


    const handleChange = async (e) => {
        const { id, value } = e.target;

        // Créez une nouvelle copie de formData avec la mise à jour immédiate
        const updatedFormData = {
            ...formData,
            [id]: value,
        };

        // Met à jour formData avec les valeurs modifiées
        setFormData(updatedFormData);

        console.log("Valeur modifiée pour", id, ":", value);

        // Videz l'erreur cumulative
        setCumulativeError("");

        // Préparez les données actuelles du formulaire pour l'envoi
        const experience_projets = formDataList;
        const sauvegardeData = {
            ...updatedFormData,  // Utilise les données mises à jour immédiatement
            experiences: experience_projets,
        };

        // Choisis l'URL appropriée en fonction de formulaire_id
        const url = formulaire_id
            ? `${process.env.REACT_APP_HOTE}/modification-temporaire-eligibilite/${user_id}/${formulaire_id}/`
            : `${process.env.REACT_APP_HOTE}/sauvegarder-eligibilite/${user_id}/`;

        try {

            // Récupérer le token d'authentification
            const token = localStorage.getItem('access_token');

            // Appel au backend pour sauvegarder les données
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(sauvegardeData),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la sauvegarde des données.');
            }

            const responseData = await response.json();
            console.log('Données sauvegardées/modifiées avec succès :', responseData);
        } catch (error) {
            console.error('Erreur lors de la sauvegarde des données :', error);
            // setCumulativeError("Une erreur s'est produite lors de la sauvegarde.");
        }
    };

    const handleChangeProjet = async (index, e) => {
        const { name, value } = e.target;

        if (name === 'date_debut_projet' || name === 'date_fin_projet') {
            if (value) {
                const selectedDate = new Date(value);
                const tenYearsAgo = new Date();
                tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10);
                tenYearsAgo.setHours(0, 0, 0, 0);

                if (selectedDate < tenYearsAgo) {
                    setCumulativeError(
                        'La date choisie ne peut pas être antérieure à ' +
                        tenYearsAgo.toLocaleDateString('fr-FR') +
                        ' (limite de 10 ans en arrière).'
                    );
                    return; // on bloque la mise à jour
                }
            }
        }

        // Créez une nouvelle copie de formDataList avec la mise à jour immédiate
        const updatedFormDataList = [...formDataList];

        // Mettez à jour le champ spécifique du projet à l'index donné
        updatedFormDataList[index] = {
            ...updatedFormDataList[index],
            [name]: value,
        };

        // Gestion du compteur de mots pour la description
        if (name === 'description') {
            const wordsArray = value.trim().split(/\s+/);
            const wordCount = wordsArray.filter(word => word.length > 0).length;

            if (wordCount > maxWordCount) {
                return; // Annule si le compteur de mots dépasse la limite
            }

            updatedFormDataList[index].wordCount = wordCount;
            // localStorage.setItem('wordCounts', JSON.stringify({
            //     ...JSON.parse(localStorage.getItem('wordCounts') || '{}'),
            //     [`wordCount${index}`]: wordCount,
            // }));
        }

        if (name === 'titre_projet') {
            if (value.length > 200) {
                setCumulativeError('Le titre projet ne doit pas dépasser 200 caractères.');
                return;
            }
        }

        // Calculer la durée du projet en mois si les deux dates sont valides
        const { date_debut_projet, date_fin_projet } = updatedFormDataList[index];
        if (date_debut_projet && date_fin_projet) {
            updatedFormDataList[index].duree_projet_mois = calculateMonths(date_debut_projet, date_fin_projet);
        }

        // Met à jour l'état pour refléter les modifications
        setFormDataList(updatedFormDataList);
        setValidationMois('');
        setCumulativeError('');
        setErrorList(['']);

        // Préparez les données actuelles pour l'envoi
        const sauvegardeData = {
            ...formData,
            experiences: updatedFormDataList,
        };

        // Choisissez l'URL en fonction de formulaire_id
        const url = formulaire_id
            ? `${process.env.REACT_APP_HOTE}/modification-temporaire-eligibilite/${user_id}/${formulaire_id}/`
            : `${process.env.REACT_APP_HOTE}/sauvegarder-eligibilite/${user_id}/`;

        try {

            // Récupérer le token d'authentification
            const token = localStorage.getItem('access_token');

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(sauvegardeData),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la sauvegarde des données.');
            }

            const responseData = await response.json();
            console.log('Données sauvegardées/modifiées avec succès :', responseData);
        } catch (error) {
            console.error('Erreur lors de la sauvegarde des données :', error);
            // setCumulativeError("Une erreur s'est produite lors de la sauvegarde.");
        }
    };


    const addNewProject = () => {
        const newErrorList = [...errorList];
        let valid = true;

        formDataList.forEach((formData, index) => {
            const wordCount = formData.description.split(' ').length;
            if (wordCount < 200 || wordCount > 500) {
                newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
                // setCumulativeError("La description doit contenir entre 200 et 500 mots.");
                valid = false;
            }
            if (formData.date_debut_projet && formData.date_fin_projet) {
                const startDate = new Date(formData.date_debut_projet);
                const endDate = new Date(formData.date_fin_projet);
                if (endDate <= startDate) {
                    newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
                    // setCumulativeError("La date de début doit être antérieure à la date de fin.");
                    valid = false;
                }
            }
            if (Object.values(formData).some(field => field === "")) {
                newErrorList[index] = 'Tous les champs doivent être remplis.';
                valid = false;
                return;
            }
        });

        if (valid) {
            setFormDataList([...formDataList, {
                // id: '',
                titre_projet: '',
                organisation: '',
                poste_occupe: '',
                domaine_fonctionnel: '',
                objectif_organisation: '',
                approche_methodologique: '',
                taille_equipe: '',
                budget: '',
                date_debut_projet: '',
                date_fin_projet: '',
                description: '',
            }]);
            setErrorList([...newErrorList, '']);
            setExpanded([...expanded, true]);
        } else {
            setErrorList(newErrorList);
        }
    };

    const handleToggle = (index) => {
        const newExpanded = [...expanded];
        newExpanded[index] = !newExpanded[index]; // Basculer l'état d'expansion
        setExpanded(newExpanded);
    };

    const [showModal, setShowModal] = useState(false);
    const [projectToDelete, setProjectToDelete] = useState(null); // Pour stocker l'index du projet à supprimer

    const handleDelete = (index) => {
        setProjectToDelete(index); // Stockez l'index à supprimer
        setShowModal(true); // Affichez la modale
    };

    const confirmDelete = async () => {
        if (projectToDelete !== null) {
            const newFormDataList = formDataList.filter((_, i) => i !== projectToDelete);
            setFormDataList(newFormDataList);

            // Utilisez newFormDataList pour créer experience_projets
            const experience_projets = newFormDataList;
            const sauvegardeData = {
                ...formData,
                experiences: experience_projets,
            };

            // Choisissez l'URL en fonction de formulaire_id
            const url = formulaire_id
                ? `${process.env.REACT_APP_HOTE}/modification-temporaire-eligibilite/${user_id}/${formulaire_id}/`
                : `${process.env.REACT_APP_HOTE}/sauvegarder-eligibilite/${user_id}/`;

            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(sauvegardeData),
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de la sauvegarde des données.');
                }

                const responseData = await response.json();
                console.log('Données sauvegardées/modifiées avec succès :', responseData);
            } catch (error) {
                console.error('Erreur lors de la sauvegarde des données :', error);
                setCumulativeError("Une erreur s'est produite lors de la sauvegarde. Réessayer");
            }
            setShowModal(false); // Fermez la modale
        }
    };


    const handleClose = () => {
        setShowModal(false); // Fermez la modale sans supprimer
        setProjectToDelete(null); // Réinitialisez l'index
    };


    const [alert, setAlert] = useState({ message: '', type: '' });
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });

        }, 7000);
    };

    const Enregistrer = async () => {
        const newErrorList = [...errorList];
        let valid = true;
        const areDatesOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
            return (startDate1 <= endDate2 && startDate2 <= endDate1);
        };
        let hasOverlappingProjects = false;
        let overlappingProjects = []; // Tableau pour stocker les projets qui se chevauchent


        // Validation pour chaque projet dans formDataList
        formDataList.forEach((formData, index) => {
            const wordCount = formData.description.split(' ').length;

            // // Vérification du nombre de mots
            // if (wordCount < 200 || wordCount > 500) {
            //     newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
            //     console.log("errorlist", errorList);
            //     valid = false;
            // } else {
            //     setErrorList([...newErrorList, '']);
            // }

            // Vérification des dates de projet
            const startDate = new Date(formData.date_debut_projet);
            const endDate = new Date(formData.date_fin_projet);
            if (endDate <= startDate) {
                newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
                valid = false;
            }

            // Vérification des chevauchements avec les autres projets

            formDataList.forEach((otherFormData, otherIndex) => {
                if (index !== otherIndex) {
                    const otherStartDate = new Date(otherFormData.date_debut_projet);
                    const otherEndDate = new Date(otherFormData.date_fin_projet);

                    if (areDatesOverlapping(startDate, endDate, otherStartDate, otherEndDate)) {
                        newErrorList[index] = `Les dates de ce projet chevauchent celles du projet "${otherFormData.titre_projet}".`;
                        valid = false;
                        hasOverlappingProjects = true;

                        // Ajouter le nom des deux projets dans le tableau des projets en conflit
                        overlappingProjects.push({
                            projet1: formData.titre_projet,
                            projet2: otherFormData.titre_projet,
                        });
                    }
                }
            });

            // // Vérification des champs vides
            // if (Object.values(formData).some(field => field === "")) {
            //     newErrorList[index] = 'Tous les champs doivent être remplis...';
            //     valid = false;
            //     return; // Sortie de la boucle
            // }
        });

        if (hasOverlappingProjects) {
            // Message d'erreur global avec les projets en conflit
            const overlappingMessage = overlappingProjects.map(
                proj => `Le projet "${proj.projet1}" chevauche le projet "${proj.projet2}".`
            ).join(' ');

            setCumulativeError(`Les dates de certains projets se chevauchent. Détails : ${overlappingMessage}`);
            valid = false;
        }
        setErrorList(newErrorList);

        if (!valid) {
            window.scrollTo(0, 0); // Défilement en haut de la page en cas d'erreur
            return false; // Ne pas continuer si le formulaire n'est pas valide
        }

        // Préparez les données actuelles du formulaire 
        const experience_projets = formDataList;
        const sauvegardeData = {
            ...formData,
            experiences: experience_projets,
        };

        // Choisissez l'URL en fonction de formulaire_id
        const url = formulaire_id
            ? `${process.env.REACT_APP_HOTE}/modification-temporaire-eligibilite/${user_id}/${formulaire_id}/`
            : `${process.env.REACT_APP_HOTE}/sauvegarder-eligibilite/${user_id}/`;

        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(sauvegardeData),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la sauvegarde des données.');
            }

            const responseData = await response.json();
            console.log('Données sauvegardées/modifiées avec succès :', responseData);
            showAlert("Les données sont enregistrés avec succès !");
            window.scrollTo(0, 0); // Défilement en haut de la page
        } catch (error) {
            console.error('Erreur lors de la sauvegarde des données :', error);
            setCumulativeError("Une erreur s'est produite lors de la sauvegarde. Réessayer");
        }
    };

    const SauvegarderDeSuivant = async () => {
        if (formulaire_id) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-utilisateur/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                console.log('Données dans champs modifies :', data);

                // Remplir les champs avec des données
                setFormData(data);
                setFormDataList(data.experiences);
                // setDataEligibilite(data);
            } catch (error) {
                console.error("L'utilisateur n'a probablement pas de formulaire enregistré:", error);
            }
        } else {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/charger-eligibilite/${user_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(process.env.REACT_APP_HOTE + `/charger-eligibilite/${user_id}/`);
                if (!response.ok) {
                    throw new Error("Erreur lors de la récupération des données.");
                }

                const existingData = await response.json();
                console.log('Données à charger de JSON :', existingData);

                // Mise à jour de formData avec les données récupérées
                setFormData(existingData);

                // Vérifie si des expériences existent dans les données récupérées
                if (existingData.experiences && existingData.experiences.length > 0) {
                    console.log("Des expériences ont été trouvées :", existingData.experiences);
                    setFormDataList(existingData.experiences);
                } else {
                    console.log("Aucune expérience trouvée, formulaire vide initialisé");
                    setFormDataList([{
                        // id: '',
                        titre_projet: '',
                        organisation: '',
                        poste_occupe: '',
                        domaine_fonctionnel: '',
                        objectif_organisation: '',
                        approche_methodologique: '',
                        taille_equipe: '',
                        budget: '',
                        date_debut_projet: '',
                        date_fin_projet: '',
                        description: '',
                    }]);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données du formulaire:', error);
            }
        }
        // if (currentStep === 4) {
        // const { niveau_eleve } = formData;
        // const newErrorList = [...errorList];
        // let valid = true;
        // const areDatesOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
        //     return (startDate1 <= endDate2 && startDate2 <= endDate1);
        // };
        // let hasOverlappingProjects = false;
        // let overlappingProjects = []; // Tableau pour stocker les projets qui se chevauchent


        // // Validation pour chaque projet dans formDataList
        // formDataList.forEach((formData, index) => {
        //     const wordCount = formData.description.split(' ').length;

        //     // Vérification du nombre de mots
        //     if (wordCount < 200 || wordCount > 500) {
        //         newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
        //         valid = false;
        //     } else {
        //         setErrorList([...newErrorList, '']);
        //     }

        //     // Vérification des dates de projet
        //     const startDate = new Date(formData.date_debut_projet);
        //     const endDate = new Date(formData.date_fin_projet);
        //     if (endDate <= startDate) {
        //         newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
        //         valid = false;
        //     }

        //     // Vérification des chevauchements avec les autres projets

        //     formDataList.forEach((otherFormData, otherIndex) => {
        //         if (index !== otherIndex) {
        //             const otherStartDate = new Date(otherFormData.date_debut_projet);
        //             const otherEndDate = new Date(otherFormData.date_fin_projet);

        //             if (areDatesOverlapping(startDate, endDate, otherStartDate, otherEndDate)) {
        //                 newErrorList[index] = `Les dates de ce projet chevauchent celles du projet "${otherFormData.titre_projet}".`;
        //                 valid = false;
        //                 hasOverlappingProjects = true;

        //                 // Ajouter le nom des deux projets dans le tableau des projets en conflit
        //                 overlappingProjects.push({
        //                     projet1: formData.titre_projet,
        //                     projet2: otherFormData.titre_projet,
        //                 });
        //             }
        //         }
        //     });

        //     // Vérification des champs vides
        //     if (Object.values(formData).some(field => field === "")) {
        //         newErrorList[index] = 'Tous les champs doivent être remplis...';
        //         valid = false;
        //         return; // Sortie de la boucle
        //     }
        // });

        // if (hasOverlappingProjects) {
        //     // Message d'erreur global avec les projets en conflit
        //     const overlappingMessage = overlappingProjects.map(
        //         proj => `Le projet "${proj.projet1}" chevauche le projet "${proj.projet2}".`
        //     ).join(' ');

        //     setCumulativeError(`Les dates de certains projets se chevauchent. Détails : ${overlappingMessage}`);
        //     valid = false;
        // }

        // // Définir le seuil de mois minimum en fonction du niveau d'éducation
        // const minimumMonthsRequired = ['Master1', 'Master2', 'Doctorat', 'Ingénieur', 'Licence', 'Autres'].includes(niveau_eleve) ? 36 : 60;

        // // Vérification du total des mois d'expérience en fonction du niveau
        // if (totalMonths < minimumMonthsRequired) {
        //     setValidationMois('');
        //     setCumulativeError(`Le total des mois d'expérience doit être d'au moins ${minimumMonthsRequired} mois. Vous avez actuellement déclaré ${totalMonths}/${minimumMonthsRequired} mois. Il vous en reste ${minimumMonthsRequired - totalMonths} à déclarer. Veuillez ajouter un autre projet pour atteindre les ${minimumMonthsRequired} mois requis ou remplacer le(s) projet(s) existants par un(des) projet(s) de plus longue durée.`);  // Affiche le message d'erreur global`);
        //     valid = false;  // Bloquer l'envoi si la condition n'est pas remplie
        // } else {
        //     const hasExceedingProjects = formDataList.some((formData) => {
        //         const months = calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
        //         return months >= minimumMonthsRequired && formDataList.length > 1;
        //     });

        //     if (hasExceedingProjects) {
        //         setCumulativeError(`L'un de vos projets atteint déjà les ${minimumMonthsRequired} mois de durée requis. Vous ne pouvez pas soumettre un autre projet de plus.`);
        //         valid = false;
        //     } else {
        //         setCumulativeError(''); // Pas d'erreur si tout est correct
        //     }
        // }
        // setErrorList(newErrorList);

        // if (!valid) {
        //     window.scrollTo(0, 0); // Défilement en haut de la page en cas d'erreur
        //     return false; // Ne pas continuer si le formulaire n'est pas valide
        // } 
        // }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Données du formulaire chargées :', formData);

        const { annee_debut_education, annee_fin_education, date_debut_cours, date_fin_cours, niveau_eleve } = formData;

        // Vérification des années
        if (parseInt(annee_debut_education) >= parseInt(annee_fin_education)) {
            setCumulativeError("L'année de début doit être antérieure à l'année de fin.");
            return;
        }

        // Vérification des dates
        if (new Date(date_debut_cours) >= new Date(date_fin_cours)) {
            setCumulativeError("La date de début doit être antérieure à la date de fin.");
            return;
        }

        // Vérification des champs vides
        if (Object.values(formData).some(field => field === "")) {
            setCumulativeError("Tous les champs doivent être remplis.");
            return;
        }

        const newErrorList = [...errorList];
        let valid = true;
        const areDatesOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
            return (startDate1 <= endDate2 && startDate2 <= endDate1);
        };
        let hasOverlappingProjects = false;
        let overlappingProjects = [];

        // Validation pour chaque projet dans formDataList
        formDataList.forEach((formData, index) => {
            const wordCount = formData.description.trim().split(/\s+/).length;
            // setNbre(formDataList[index].wordCount);

            // Vérification du nombre de mots
            if (wordCount < 200 || wordCount > 500) {
                newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
                valid = false;
            } else {
                setErrorList([...newErrorList, '']);
            }

            // // Vérification du nombre de mots
            // if (wordForProjects[index] < 200 ||wordForProjects > 500) {
            //     newErrorList[index] = 'La description doit contenir entre 200 et 500 mots.';
            //     valid = false;
            // } else {
            //     setErrorList([...newErrorList, '']);
            // }

            // Vérification des dates de projet
            const startDate = new Date(formData.date_debut_projet);
            const endDate = new Date(formData.date_fin_projet);
            if (endDate <= startDate) {
                newErrorList[index] = 'La date de début doit être antérieure à la date de fin.';
                valid = false;
            }

            // Vérification des chevauchements avec les autres projets
            formDataList.forEach((otherFormData, otherIndex) => {
                if (index !== otherIndex) {
                    const otherStartDate = new Date(otherFormData.date_debut_projet);
                    const otherEndDate = new Date(otherFormData.date_fin_projet);

                    if (areDatesOverlapping(startDate, endDate, otherStartDate, otherEndDate)) {
                        newErrorList[index] = `Les dates de ce projet chevauchent celles du projet "${otherFormData.titre_projet}".`;
                        valid = false;
                        hasOverlappingProjects = true;
                        overlappingProjects.push({
                            projet1: formData.titre_projet,
                            projet2: otherFormData.titre_projet,
                        });
                    }
                }
            });

            // Vérification des champs vides
            if (Object.values(formData).some(field => field === "")) {
                newErrorList[index] = 'Tous les champs doivent être remplis.';
                valid = false;
                return;
            }
        });

        if (hasOverlappingProjects) {
            const overlappingMessage = overlappingProjects.map(
                proj => `Le projet "${proj.projet1}" chevauche le projet "${proj.projet2}".`
            ).join(' ');
            setCumulativeError(`Les dates de certains projets se chevauchent. Détails : ${overlappingMessage}`);
            valid = false;
        }

        // Définir le seuil de mois minimum en fonction du niveau d'éducation
        const minimumMonthsRequired = ['Master1', 'Master2', 'Doctorat', 'Ingénieur', 'Licence', 'Autres'].includes(niveau_eleve) ? 36 : 60;

        // Vérification du total des mois d'expérience en fonction du niveau
        if (totalMonths < minimumMonthsRequired) {
            setValidationMois('');
            setCumulativeError(`Le total des mois d'expérience doit être d'au moins ${minimumMonthsRequired} mois. Vous avez actuellement déclaré ${totalMonths}/${minimumMonthsRequired} mois. Il vous en reste ${minimumMonthsRequired - totalMonths} à déclarer. Veuillez ajouter un autre projet pour atteindre les ${minimumMonthsRequired} mois requis ou remplacer le(s) projet(s) existants par un(des) projet(s) de plus longue durée.`);  // Affiche le message d'erreur global`);
            valid = false;  // Bloquer l'envoi si la condition n'est pas remplie
        } else {
            const hasExceedingProjects = formDataList.some((formData) => {
                const months = calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
                return months >= minimumMonthsRequired && formDataList.length > 1;
            });

            if (hasExceedingProjects) {
                setCumulativeError(`L'un de vos projets atteint déjà les ${minimumMonthsRequired} mois de durée requis. Vous ne pouvez pas soumettre un autre projet de plus.`);
                valid = false;
            } else {
                setCumulativeError(''); // Pas d'erreur si tout est correct
            }
        }

        setErrorList(newErrorList);

        let experience_projets = formDataList;
        const eligibiliteEntier = {
            ...formData,
            experiences: experience_projets,
        };
        console.log('Yes :', eligibiliteEntier);

        if (!valid) {
            window.scrollTo(0, 0); // Défilement en haut de la page en cas d'erreur
            return; // Ne pas continuer si le formulaire n'est pas valide
        }

        // Envoie des données au fichier JSON
        try {
            const token = localStorage.getItem('access_token');

            // Appel au back-end pour sauvegarder dans un fichier JSON
            const response = await fetch(`${process.env.REACT_APP_HOTE}/sauvegarder-eligibilite/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(eligibiliteEntier),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la sauvegarde des données.');
            }

            const responseData = await response.json();
            console.log('Données sauvegardées avec succès :', responseData);
        } catch (error) {
            console.error('Erreur lors de la sauvegarde des données :', error);
            // setCumulativeError("Une erreur s'est produite lors de la sauvegarde.");
        }

        // Envoi des données au serveur
        try {
            const url = formulaire_id
                ? process.env.REACT_APP_HOTE + `/modifier-eligibilite/${user_id}/${formulaire_id}/`
                : process.env.REACT_APP_HOTE + `/soumettre-eligibilite/${user_id}/`;

            const token = localStorage.getItem('access_token');

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(eligibiliteEntier),
            });

            if (!response.ok) {
                throw new Error("Erreur lors de l'envoi des données.");
            }

            const responseData = await response.json();
            console.log('Données soumises avec succès enfin:', responseData);
            setEtapeComplete(5);
            window.scrollTo(0, 0);
            showAlert("Données soumises avec succès !");
            // Attendre 3 secondes (3000 millisecondes) avant de rediriger vers le dashboard
            setTimeout(() => {
                navigate(`/dashboard`);
            }, 3000); // Délai de 3 secondes

        } catch (error) {
            console.error("Erreur lors de la soumission du formulaire :", error);
            setCumulativeError("Une erreur s'est produite lors de la soumission.");
        }
    };






    // Conteneur pour les étapes
    const StepsContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 30px;
position: relative;
width: 100%;

@media (max-width: 768px) {
  justify-content: space-around; // Pour assurer un espacement correct sur petit écran
}
`;

    // Ligne reliant les cercles
    const StepsLine = styled.div`
position: absolute;
top: 50%; // Positionne la ligne au centre des cercles
left: 0;
right: 0;
height: 2px;
background-color: #ddd;
z-index: 1; // Derrière les cercles
`;

    // Style pour chaque cercle
    const StepCircle = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 40px;
height: 40px;
background-color: #ddd;
border-radius: 50%;
font-size: 18px;
color: #333;
z-index: 2; // S'assurer que le cercle est au-dessus de la ligne

${({ isActive }) => isActive && `
  background-color: #1c84c6;
  color: white;
`}

${({ isCompleted }) => isCompleted && `
  background-color: #28a745; //#1ab394
  color: white;
`}
`;


    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("eligibilite")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* isloading pour le chargement */}

            <div id="wrapper" style={{ fontFamily: 'Arial, sans-serif' }}>
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div>
                        <div className="row wrapper border-bottom white-bg page-heading">
                            <div className="col-lg-12">
                                <h2 className='d-flex align-items-center'><FaUserShield size={25} className='mr-2' />Eligibilité </h2>
                                <small>Formulaire d'éligibilité.</small>

                                <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                    <ol className="breadcrumb custom-breadcrumb">
                                        <li className="breadcrumb-item custom-breadcrumb-item">
                                            {/* Utiliser Link de react-router-dom pour la navigation */}
                                            <Link to={`/eligibilite`}>Eligibilité</Link>
                                        </li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                        {alert.message && (
                            <div className={`alert alert-${alert.type}`} style={{ marginTop: '10px' }}>
                                {alert.message}
                            </div>
                        )}
                        {/* <Header titre="Eligibilité" sous_titre="Dashboard" sous_titre1="Eligibilite" /> */}
                        <div className=" d-flex flex-wrap justify-content-between" style={{ display: 'flex' }}>
                            <div className="col-lg-8 col-md-6 col-sm-12 mx-auto m-4 ">
                                {/* Essai */}
                                <div className="ibox-content">
                                    {/* Cercles des étapes */}
                                    <>
                                        <StepsContainer>
                                            {/* Ligne reliant les cercles */}
                                            <StepsLine />

                                            {/* Étape 1 */}
                                            <StepCircle
                                                isActive={currentStep === 1}
                                                isCompleted={currentStep > 1}
                                                title="Identification"
                                            >1</StepCircle>

                                            {/* Étape 2 */}
                                            <StepCircle isActive={currentStep === 2} isCompleted={(currentStep < 2 && etapeComplete >= 2) || currentStep > 2} title='Education academique'>2</StepCircle>

                                            {/* Étape 3 */}
                                            <StepCircle isActive={currentStep === 3} isCompleted={(currentStep < 3 && etapeComplete >= 3) || currentStep > 3} title='Formation professionnelle'>3</StepCircle>

                                            {/* Étape 4 */}
                                            <StepCircle isActive={currentStep === 4} isCompleted={(currentStep < 4 && etapeComplete >= 4) || currentStep > 4} title='Experience projet'>4</StepCircle>

                                            {/* Étape 5 */}
                                            <StepCircle isActive={currentStep === 5} isCompleted={(currentStep < 5 && etapeComplete === 5) || etapeComplete > 5} title='Experience projet'>5</StepCircle>
                                        </StepsContainer>

                                        {/* <StepsContainer>
                                        <StepText>Identification</StepText>
                                        <StepText>Éducation Académique</StepText>
                                        <StepText>Formation Professionnelle</StepText>
                                        <StepText>Expérience Projet</StepText>
                                    </StepsContainer> */}
                                    </>
                                    <form onSubmit={handleSubmit}>
                                        {currentStep === 1 && (
                                            <>
                                                {/* Étape 1 : Identification */}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Identification</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                <div className="row" style={{ marginBottom: "" }}>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="prenoms">
                                                            <Form.Label style={{ display: 'block' }}> Prénoms<small style={{ display: 'block' }}>Firstname</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="prenoms"
                                                                value={userData.prenoms}
                                                                readOnly
                                                                placeholder="Prénoms"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="nom">
                                                            <Form.Label style={{ display: 'block' }}> Nom <small style={{ display: 'block' }}>Name</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="nom"
                                                                value={userData.nom}
                                                                readOnly
                                                                placeholder="Nom"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                <div className="row" style={{ marginBottom: "15px" }}>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="email">
                                                            <Form.Label style={{ display: 'block' }}> Email <small style={{ display: 'block' }}>Mail</small></Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={userData.email}
                                                                readOnly
                                                                placeholder="Email"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="tel">
                                                            <Form.Label style={{ display: 'block' }}> Numéro de téléphone <small style={{ display: 'block' }}>Phone number</small></Form.Label>
                                                            <Form.Control
                                                                type="tel"
                                                                name="tel"
                                                                value={userData.tel}
                                                                readOnly
                                                                placeholder="Téléphone WhatsApp"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {currentStep === 2 && (
                                            <>
                                                {/* Étape 2 : Éducation Académique */}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Academic Education/ Éducation académique</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <div className="row">

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="niveau_eleve" className="">
                                                            <Form.Label style={{ display: 'block' }}> Niveau élevé d'éducation<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Highest level of education</small></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="niveau_eleve"
                                                                value={formData.niveau_eleve}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Selectionnez un niveau</option>
                                                                <option value="BAC">BAC</option>
                                                                <option value="BTS">BTS</option>
                                                                <option value="Licence">Licence</option>
                                                                <option value="Master1">Master1</option>
                                                                <option value="Master2">Master2</option>
                                                                <option value="Doctorat">Doctorat</option>
                                                                <option value="Ingénieur">Ingénieur</option>
                                                                <option value="Autres">Autres</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="pays" className="">
                                                            <Form.Label style={{ display: 'block' }}> Pays<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Country</small></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="pays"
                                                                value={formData.pays}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="Choisissez votre pays">Choisissez votre pays</option>
                                                                <option value="Aaland Islands">Aaland Islands</option>
                                                                <option value="Afghanistan">Afghanistan</option>
                                                                <option value="Albania">Albania</option>
                                                                <option value="Algeria">Algeria</option>
                                                                <option value="American Samoa">American Samoa</option>
                                                                <option value="Andorra">Andorra</option>
                                                                <option value="Angola">Angola</option>
                                                                <option value="Anguilla">Anguilla</option>
                                                                <option value="Antarctica">Antarctica</option>
                                                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                                                <option value="Argentina">Argentina</option>
                                                                <option value="Armenia">Armenia</option>
                                                                <option value="Aruba">Aruba</option>
                                                                <option value="Australia">Australia</option>
                                                                <option value="Austria">Austria</option>
                                                                <option value="Azerbaijan">Azerbaijan</option>
                                                                <option value="Bahamas">Bahamas</option>
                                                                <option value="Bahrain">Bahrain</option>
                                                                <option value="Bangladesh">Bangladesh</option>
                                                                <option value="Barbados">Barbados</option>
                                                                <option value="Belarus">Belarus</option>
                                                                <option value="Belgium">Belgium</option>
                                                                <option value="Belize">Belize</option>
                                                                <option value="Benin">Benin</option>
                                                                <option value="Bermuda">Bermuda</option>
                                                                <option value="Bhutan">Bhutan</option>
                                                                <option value="Bolivia">Bolivia</option>
                                                                <option value="Bonaire, Sint Eustatius and Saba">Bonaire, Sint Eustatius and Saba</option>
                                                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                                                <option value="Botswana">Botswana</option>
                                                                <option value="Bouvet Island">Bouvet Island</option>
                                                                <option value="Brazil">Brazil</option>
                                                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                                                <option value="Bulgaria">Bulgaria</option>
                                                                <option value="Burkina Faso">Burkina Faso</option>
                                                                <option value="Burundi">Burundi</option>
                                                                <option value="Cambodia">Cambodia</option>
                                                                <option value="Cameroon">Cameroon</option>
                                                                <option value="Canada">Canada</option>
                                                                <option value="Canary Islands">Canary Islands</option>
                                                                <option value="Cape Verde">Cape Verde</option>
                                                                <option value="Cayman Islands">Cayman Islands</option>
                                                                <option value="Central African Republic">Central African Republic</option>
                                                                <option value="Chad">Chad</option>
                                                                <option value="Chile">Chile</option>
                                                                <option value="China">China</option>
                                                                <option value="Christmas Island">Christmas Island</option>
                                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                                                <option value="Colombia">Colombia</option>
                                                                <option value="Comoros">Comoros</option>
                                                                <option value="Congo">Congo</option>
                                                                <option value="Cook Islands">Cook Islands</option>
                                                                <option value="Costa Rica">Costa Rica</option>
                                                                <option value="Cote D'Ivoire">Cote D'Ivoire</option>
                                                                <option value="Croatia">Croatia</option>
                                                                <option value="Cuba">Cuba</option>
                                                                <option value="Curacao">Curacao</option>
                                                                <option value="Cyprus">Cyprus</option>
                                                                <option value="Czech Republic">Czech Republic</option>
                                                                <option value="Democratic Republic of Congo">Democratic Republic of Congo</option>
                                                                <option value="Denmark">Denmark</option>
                                                                <option value="Djibouti">Djibouti</option>
                                                                <option value="Dominica">Dominica</option>
                                                                <option value="Dominican Republic">Dominican Republic</option>
                                                                <option value="East Timor">East Timor</option>
                                                                <option value="Ecuador">Ecuador</option>
                                                                <option value="Egypt">Egypt</option>
                                                                <option value="El Salvador">El Salvador</option>
                                                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                                                <option value="Eritrea">Eritrea</option>
                                                                <option value="Estonia">Estonia</option>
                                                                <option value="Ethiopia">Ethiopia</option>
                                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                                                <option value="Faroe Islands">Faroe Islands</option>
                                                                <option value="Fiji">Fiji</option>
                                                                <option value="Finland">Finland</option>
                                                                <option value="France">France</option>
                                                                <option value="French Guiana">French Guiana</option>
                                                                <option value="French Polynesia">French Polynesia</option>
                                                                <option value="French Southern Territories">French Southern Territories</option>
                                                                <option value="FYROM">FYROM</option>
                                                                <option value="Gabon">Gabon</option>
                                                                <option value="Gambia">Gambia</option>
                                                                <option value="Georgia">Georgia</option>
                                                                <option value="Germany">Germany</option>
                                                                <option value="Ghana">Ghana</option>
                                                                <option value="Gibraltar">Gibraltar</option>
                                                                <option value="Greece">Greece</option>
                                                                <option value="Greenland">Greenland</option>
                                                                <option value="Grenada">Grenada</option>
                                                                <option value="Guadeloupe">Guadeloupe</option>
                                                                <option value="Guam">Guam</option>
                                                                <option value="Guatemala">Guatemala</option>
                                                                <option value="Guernsey">Guernsey</option>
                                                                <option value="Guinea">Guinea</option>
                                                                <option value="Guinea-Bissau">Guinea-Bissau</option>
                                                                <option value="Guyana">Guyana</option>
                                                                <option value="Haiti">Haiti</option>
                                                                <option value="Heard and Mc Donald Islands">Heard and Mc Donald Islands</option>
                                                                <option value="Honduras">Honduras</option>
                                                                <option value="Hong Kong">Hong Kong</option>
                                                                <option value="Hungary">Hungary</option>
                                                                <option value="Iceland">Iceland</option>
                                                                <option value="India">India</option>
                                                                <option value="Indonesia">Indonesia</option>
                                                                <option value="Iran (Islamic Republic of)">Iran (Islamic Republic of)</option>
                                                                <option value="Iraq">Iraq</option>
                                                                <option value="Ireland">Ireland</option>
                                                                <option value="Israel">Israel</option>
                                                                <option value="Italy">Italy</option>
                                                                <option value="Jamaica">Jamaica</option>
                                                                <option value="Japan">Japan</option>
                                                                <option value="Jersey">Jersey</option>
                                                                <option value="Jordan">Jordan</option>
                                                                <option value="Kazakhstan">Kazakhstan</option>
                                                                <option value="Kenya">Kenya</option>
                                                                <option value="Kiribati">Kiribati</option>
                                                                <option value="Korea, Republic of">Korea, Republic of</option>
                                                                <option value="Kuwait">Kuwait</option>
                                                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                                <option value="Latvia">Latvia</option>
                                                                <option value="Lebanon">Lebanon</option>
                                                                <option value="Lesotho">Lesotho</option>
                                                                <option value="Liberia">Liberia</option>
                                                                <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                                                <option value="Liechtenstein">Liechtenstein</option>
                                                                <option value="Lithuania">Lithuania</option>
                                                                <option value="Luxembourg">Luxembourg</option>
                                                                <option value="Macau">Macau</option>
                                                                <option value="Madagascar">Madagascar</option>
                                                                <option value="Malawi">Malawi</option>
                                                                <option value="Malaysia">Malaysia</option>
                                                                <option value="Maldives">Maldives</option>
                                                                <option value="Mali">Mali</option>
                                                                <option value="Malta">Malta</option>
                                                                <option value="Marshall Islands">Marshall Islands</option>
                                                                <option value="Martinique">Martinique</option>
                                                                <option value="Mauritania">Mauritania</option>
                                                                <option value="Mauritius">Mauritius</option>
                                                                <option value="Mayotte">Mayotte</option>
                                                                <option value="Mexico">Mexico</option>
                                                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                                                <option value="Moldova, Republic of">Moldova, Republic of</option>
                                                                <option value="Monaco">Monaco</option>
                                                                <option value="Mongolia">Mongolia</option>
                                                                <option value="Montenegro">Montenegro</option>
                                                                <option value="Montserrat">Montserrat</option>
                                                                <option value="Morocco">Morocco</option>
                                                                <option value="Mozambique">Mozambique</option>
                                                                <option value="Myanmar">Myanmar</option>
                                                                <option value="Namibia">Namibia</option>
                                                                <option value="Nauru">Nauru</option>
                                                                <option value="Nepal">Nepal</option>
                                                                <option value="Netherlands">Netherlands</option>
                                                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                                                <option value="New Caledonia">New Caledonia</option>
                                                                <option value="New Zealand">New Zealand</option>
                                                                <option value="Nicaragua">Nicaragua</option>
                                                                <option value="Niger">Niger</option>
                                                                <option value="Nigeria">Nigeria</option>
                                                                <option value="Niue">Niue</option>
                                                                <option value="Norfolk Island">Norfolk Island</option>
                                                                <option value="North Korea">North Korea</option>
                                                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                                <option value="Norway">Norway</option>
                                                                <option value="Oman">Oman</option>
                                                                <option value="Pakistan">Pakistan</option>
                                                                <option value="Palau">Palau</option>
                                                                <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                                                <option value="Panama">Panama</option>
                                                                <option value="Papua New Guinea">Papua New Guinea</option>
                                                                <option value="Paraguay">Paraguay</option>
                                                                <option value="Peru">Peru</option>
                                                                <option value="Philippines">Philippines</option>
                                                                <option value="Pitcairn">Pitcairn</option>
                                                                <option value="Poland">Poland</option>
                                                                <option value="Portugal">Portugal</option>
                                                                <option value="Puerto Rico">Puerto Rico</option>
                                                                <option value="Qatar">Qatar</option>
                                                                <option value="Reunion">Reunion</option>
                                                                <option value="Romania">Romania</option>
                                                                <option value="Russian Federation">Russian Federation</option>
                                                                <option value="Rwanda">Rwanda</option>
                                                                <option value="Saint Helena">Saint Helena</option>
                                                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                                                <option value="Saint Lucia">Saint Lucia</option>
                                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                                                <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                                                                <option value="Samoa">Samoa</option>
                                                                <option value="San Marino">San Marino</option>
                                                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                                                <option value="Saudi Arabia">Saudi Arabia</option>
                                                                <option value="Senegal">Senegal</option>
                                                                <option value="Serbia">Serbia</option>
                                                                <option value="Seychelles">Seychelles</option>
                                                                <option value="Sierra Leone">Sierra Leone</option>
                                                                <option value="Singapore">Singapore</option>
                                                                <option value="Slovakia">Slovakia</option>
                                                                <option value="Slovenia">Slovenia</option>
                                                                <option value="Solomon Islands">Solomon Islands</option>
                                                                <option value="Somalia">Somalia</option>
                                                                <option value="South Africa">South Africa</option>
                                                                <option value="South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
                                                                <option value="South Sudan">South Sudan</option>
                                                                <option value="Spain">Spain</option>
                                                                <option value="Sri Lanka">Sri Lanka</option>
                                                                <option value="Sudan">Sudan</option>
                                                                <option value="Suriname">Suriname</option>
                                                                <option value="Svalbard and Jan Mayen Islands">Svalbard and Jan Mayen Islands</option>
                                                                <option value="Swaziland">Swaziland</option>
                                                                <option value="Sweden">Sweden</option>
                                                                <option value="Switzerland">Switzerland</option>
                                                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                                                <option value="Taiwan">Taiwan</option>
                                                                <option value="Tajikistan">Tajikistan</option>
                                                                <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                                                <option value="Thailand">Thailand</option>
                                                                <option value="Togo">Togo</option>
                                                                <option value="Tokelau">Tokelau</option>
                                                                <option value="Tonga">Tonga</option>
                                                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                                                <option value="Tunisia">Tunisia</option>
                                                                <option value="Turkey">Turkey</option>
                                                                <option value="Turkmenistan">Turkmenistan</option>
                                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                                                <option value="Tuvalu">Tuvalu</option>
                                                                <option value="Uganda">Uganda</option>
                                                                <option value="Ukraine">Ukraine</option>
                                                                <option value="United Arab Emirates">United Arab Emirates</option>
                                                                <option value="United Kingdom">United Kingdom</option>
                                                                <option value="United States">United States</option>
                                                                <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                                                <option value="Uruguay">Uruguay</option>
                                                                <option value="Uzbekistan">Uzbekistan</option>
                                                                <option value="Vanuatu">Vanuatu</option>
                                                                <option value="Vatican City State (Holy See)">Vatican City State (Holy See)</option>
                                                                <option value="Venezuela">Venezuela</option>
                                                                <option value="Viet Nam">Viet Nam</option>
                                                                <option value="Virgin Islands (British)">Virgin Islands (British)</option>
                                                                <option value="Virgin Islands (U.S.)">Virgin Islands (U.S.)</option>
                                                                <option value="Wallis and Futuna Islands">Wallis and Futuna Islands</option>
                                                                <option value="Western Sahara">Western Sahara</option>
                                                                <option value="Yemen">Yemen</option>
                                                                <option value="Zambia">Zambia</option>
                                                                <option value="Zimbabwe">Zimbabwe</option>

                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>


                                                    {/* Start Year */}

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="annee_debut_education" className="">
                                                            <Form.Label style={{ display: 'block' }}> Année Début<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Start Year</small></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="annee_debut_education"
                                                                value={formData.annee_debut_education}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Début</option>
                                                                {[...Array(new Date().getFullYear() - 1969).keys()].map(i => {
                                                                    const year = 1970 + i;
                                                                    return <option key={year} value={year}>{year}</option>;
                                                                })}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>

                                                    {/* End Year */}
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="annee_fin_education" className="">
                                                            <Form.Label style={{ display: 'block' }}> Année Fin<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>End Year</small></Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name="annee_fin_education"
                                                                value={formData.annee_fin_education}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Fin</option>
                                                                {[...Array(new Date().getFullYear() - 1969).keys()].map(i => {
                                                                    const year = 1970 + i;
                                                                    return <option key={year} value={year}>{year}</option>;
                                                                })}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>

                                                </div>
                                                {/* Country, Institution, Field of Study */}
                                                <div className="row">

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="institution" className="">
                                                            <Form.Label style={{ display: 'block' }}> Nom de l'institution<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Name of institution</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="institution"
                                                                value={formData.institution}
                                                                onChange={handleChange}
                                                                maxLength={200}
                                                                placeholder="Entrez le nom de l'institution"
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="filiere" className="">
                                                            <Form.Label style={{ display: 'block' }}> Filière<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Field of study</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="filiere"
                                                                value={formData.filiere}
                                                                onChange={handleChange}
                                                                maxLength={200}
                                                                placeholder="Entrez votre filière"
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {currentStep === 3 && (
                                            <>
                                                {/* Étape 3 : Formation Professionnelle */}
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Professional Education / Formation Professionelle :</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                <div className="row">
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="lieu_formation" className="">
                                                            <Form.Label style={{ display: 'block' }}> Lieu de formation<small style={{ display: 'block' }}>Provider Name</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lieu_formation"
                                                                value={formData.lieu_formation = lieu}
                                                                onChange={handleChange}
                                                                readOnly
                                                            // placeholder="ATP INOVACT"
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="titre_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Titre du cours<small style={{ display: 'block' }}>Course Title</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="titre_cours"
                                                                value={formData.titre_cours = titre}
                                                                onChange={handleChange}
                                                                readOnly
                                                            // placeholder="PMP Preparation Course"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="date_debut_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Date début<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Start date</small></Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="date_debut_cours"
                                                                value={formData.date_debut_cours}
                                                                onChange={handleChange}
                                                                max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="date_fin_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Date Fin<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>End date</small></Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="date_fin_cours"
                                                                value={formData.date_fin_cours}
                                                                onChange={handleChange}
                                                                max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="nombre_heures" className="">
                                                            <Form.Label style={{ display: 'block' }}> Nombre total d'heures<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Qualifying Hours</small></Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="nombre_heures"
                                                                value={formData.nombre_heures}
                                                                onChange={handleChange}
                                                                required
                                                                placeholder="Entrez le total d'heures de cours"
                                                                min="35" // Définit la valeur minimale à 35
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {currentStep === 4 && (
                                            <>
                                                {/* Étape 4 : Expérience projet */}
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>
                                                        Experience Project / Expérience Projet : {totalMonths} mois
                                                    </h3>
                                                    <Button
                                                        variant={canAddProject ? "success" : "default"} // Utilisation d'une couleur différente quand il est désactivé
                                                        onClick={addNewProject}
                                                        disabled={!canAddProject}
                                                        className="btn-large-screen" // Ajout de la classe CSS
                                                        style={{
                                                            borderRadius: '5px',
                                                            width: '100px',
                                                            height: '28px',
                                                            padding: '0',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            backgroundColor: canAddProject ? '' : '', // Couleur grise si désactivé
                                                            cursor: canAddProject ? 'pointer' : 'not-allowed' // Curseur changé quand désactivé
                                                        }}
                                                    >
                                                        Ajouter projet
                                                    </Button>
                                                </div>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                {formDataList.map((formData, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            padding: '15px',
                                                            borderRadius: '10px',
                                                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                                            transition: '0.3s',
                                                            backgroundColor: '#f8f9fa',
                                                        }}
                                                    >
                                                        <div className="d-flex justify-content-start" onClick={() => handleToggle(index)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                            {expanded[index] ? <FaCaretDown style={{ fontSize: '24px' }} /> : <FaCaretRight style={{ fontSize: '24px' }} />}
                                                            <span className="ms-2" style={{ fontSize: '15px' }}> {formData.titre_projet !== "" ? formData.titre_projet : "Nouveau projet"} : {datesForProjects[index]} {monthsForProjects && (<span> ({monthsForProjects[index]} mois) </span>)}</span>
                                                            <FaTimes
                                                                className="text-danger"
                                                                onClick={() => handleDelete(index)}
                                                                style={{ cursor: 'pointer', fontSize: '20px', marginLeft: 'auto' }}
                                                            />
                                                        </div>
                                                        {expanded[index] && (
                                                            <div className='mb-5'> <hr className="mt-2 text-muted" style={{ borderTop: '1px solid' }} />
                                                                {errorList[index] && <Alert variant="danger">{errorList[index]}</Alert>}
                                                                {/* {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>} */}
                                                                <Form>
                                                                    <div className="row">
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`titreprojet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Titre du projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Title</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="titre_projet"
                                                                                    value={formData.titre_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    maxLength={200}
                                                                                    required
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`organisation_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Organisation<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Organization</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="organisation"
                                                                                    value={formData.organisation}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    maxLength={200}
                                                                                    required
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`poste_occupe_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Poste occupé<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Job Title</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="poste_occupe"
                                                                                    value={formData.poste_occupe}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    maxLength={200}
                                                                                    required
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`domaine_fonctionnel_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Domaine fonctionnel<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Functional Reporting Area</small></Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="domaine_fonctionnel"
                                                                                    value={formData.domaine_fonctionnel}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                >
                                                                                    {/* Liste des options disponibles */}
                                                                                    <option value="">Sélectionnez un domaine fonctionnel</option>
                                                                                    <option value="Service clients">Customer Service / Service clients</option>
                                                                                    <option value="Finance">Finance / Finance</option>
                                                                                    <option value="Ressources Humaines"> Human Resources/ Ressources Humaines</option>
                                                                                    <option value="IT ou IS">IT or IS / IT ou IS</option>
                                                                                    <option value="Marketing">Marketing / Marketing</option>
                                                                                    <option value="Opérations">Operations / Opérations</option>
                                                                                    <option value="Département de gestion de projet ou PMO">PM Department or PMO / Département de gestion de projet ou PMO</option>
                                                                                    <option value="Recherche et développement">Research/R&D / Recherche et développement</option>
                                                                                    <option value="Ventes">Sales / Ventes</option>
                                                                                    <option value="Formation et éducation">Training/Education / Formation et éducation</option>
                                                                                    <option value="Non applicable">Not Applicable / Non applicable</option>
                                                                                    <option value="Autres">Other / Autres </option>
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`objectif_organisation_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Secteur d'activité<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Organization Primary Focus</small></Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="objectif_organisation"
                                                                                    value={formData.objectif_organisation}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                >
                                                                                    {/* Liste des options disponibles */}
                                                                                    <option value="">Sélectionnez un objectif</option>
                                                                                    <option value="Aérospatiale">Aerospace / Aérospatiale</option>
                                                                                    <option value="Forces armées">Armed Forces / Forces armées</option>
                                                                                    <option value="Automobile">Automotive / Automobile</option>
                                                                                    <option value="Construction">Construction / Construction</option>
                                                                                    <option value="Conseil et assistance">Consulting / Conseil et assistance</option>
                                                                                    <option value="Énergie (gaz, électricité, pétrole)">Energy (gas, electric, oil) / Énergie (gaz, électricité, pétrole)</option>
                                                                                    <option value="Services financiers">Financial Services / Services financiers</option>
                                                                                    <option value="Alimentation et boissons">Food and Beverage / Alimentation et boissons</option>
                                                                                    <option value="Gouvernement">Government / Gouvernement</option>
                                                                                    <option value="Santé">Healthcare / Santé</option>
                                                                                    <option value="Technologies de l'information">Information Technology / Technologies de l'information</option>
                                                                                    <option value="Juridique" >Legal / Juridique</option>
                                                                                    <option value="Production" >Manufacturing / Production</option>
                                                                                    <option value="Exploitation minière" >Mining / Exploitation minière</option>
                                                                                    <option value="Pharmaceutique" >Pharmaceutical / Pharmaceutique</option>
                                                                                    <option value="Télécommunication" >Telecom / Télécommunication</option>
                                                                                    <option value="Education" >Training / Education</option>
                                                                                    <option value="Aucun ou Au chomage" >None or Unemployed / Aucun ou Au chomage</option>
                                                                                    <option value="Non Applicable" >Not Applicable / Non Applicable</option>
                                                                                    <option value="Other" >Other</option>
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`approche_methodologique_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Approche méthodologique<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Approach Methodology</small></Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="approche_methodologique"
                                                                                    value={formData.approche_methodologique}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                >
                                                                                    {/* Liste des options disponibles */}
                                                                                    <option value="">Sélectionnez une approche</option>
                                                                                    <option value="Traditional (Waterfall)">Traditional (Waterfall) / Traditionnel (Cascade)</option>
                                                                                    <option value="Agile">Agile</option>
                                                                                    <option value="Hybride">Hybrid / Hybride</option>
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`taille_equipe_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Taille de l'équipe<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Team Size</small></Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="taille_equipe"
                                                                                    value={formData.taille_equipe}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                >
                                                                                    {/* Liste des options disponibles */}
                                                                                    <option value="">Sélectionnez une taile</option>
                                                                                    <option value="1 à 4">1 to 4 / 1 à 4</option>
                                                                                    <option value="5 à 9">5 to 9 / 5 à 9</option>
                                                                                    <option value="10 à 14">10 to 14 / 10 à 14</option>
                                                                                    <option value="15 à 19">15 to 19 / 15 à 19</option>
                                                                                    <option value="20 à plus">20 or more / 20 ou plus</option>
                                                                                    <option value="Classé">Classified / Classé</option>
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`budget_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Budget du projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Budget</small></Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    name="budget"
                                                                                    value={formData.budget}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                >
                                                                                    {/* Liste des options disponibles */}
                                                                                    <option value="">Sélectionnez un budget</option>
                                                                                    <option value="Jusqu'à 1 million de dollars">Up to $1M / Jusqu'à 1 million de dollars</option>
                                                                                    <option value="DE 1 À 5 MILLIONS DE DOLLARS">$1M-$5M / DE 1 À 5 MILLIONS DE DOLLARS</option>
                                                                                    <option value="DE 5 À 10 MILLIONS DE DOLLARS">$5M-$10M / DE 5 À 10 MILLIONS DE DOLLARS</option>
                                                                                    <option value="DE 10 À 25 MILLIONS DE DOLLARS">$10M-$25M / DE 10 À 25 MILLIONS DE DOLLARS</option>
                                                                                    <option value="25 millions de dollars ou plus">$25M or More / 25 millions de dollars ou plus</option>
                                                                                    <option value="Classé">Classified / Classé</option>
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`date_debut_projet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Date début projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Start Date</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="date"
                                                                                    name="date_debut_projet"
                                                                                    value={formData.date_debut_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    min={getMinDate()}
                                                                                    max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                                    required
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`date_fin_projet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Date fin projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project End Date</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="date"
                                                                                    name="date_fin_projet"
                                                                                    value={formData.date_fin_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    min={getMinDate()}
                                                                                    max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                                    required
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            <Form.Group controlId={`description_0`} className="mb-3 position-relative">
                                                                                {/* <div className=''> */}
                                                                                <Form.Label style={{ display: 'block' }}> Description du projet<span style={{ color: 'red' }}>*</span> / Project Description <small className='' style={{ display: 'block' }}><b>Nb :</b> Le nombre de mot doit etre compris entre 200 et 500.</small> </Form.Label>
                                                                                {/* <small className='' style={{ display: 'block' }}><b>Nb :</b> Le nombre de mot doit etre compris entre 200 et 500.</small> */}
                                                                                {/* </div> */}
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={3}
                                                                                    name="description"
                                                                                    // value={formDataList[index].description}
                                                                                    value={formData.description}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                />
                                                                                {/* Bouton flottant (point d'exclamation) */}
                                                                                <Button
                                                                                    variant="success"
                                                                                    className="position-absolute"
                                                                                    style={{ right: "20px", bottom: "25px", zIndex: 1 }}
                                                                                    onClick={handleShowKeywordModal}
                                                                                >
                                                                                    ?
                                                                                </Button>
                                                                                {/* <Button
                                                                                    variant="info"
                                                                                    className="position-absolute"
                                                                                    style={{ right: "20px", bottom: "25px", zIndex: 1 }}
                                                                                    onClick={() => handleChatGPTAnalysis(
                                                                                        formData.description,
                                                                                        {
                                                                                            titre: formData.titre_projet,
                                                                                            poste_occupe: formData.poste_occupe
                                                                                        }
                                                                                    )}
                                                                                    disabled={isAnalysing}
                                                                                    title='Analyser avec IA'
                                                                                >
                                                                                    {isAnalysing ? (
                                                                                        <>
                                                                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                                                            Analyse en cours...
                                                                                        </>
                                                                                    ) : (
                                                                                        '🔍'
                                                                                    )}
                                                                                </Button> */}
                                                                                <div className="word-count text-right">
                                                                                    <strong>Nombre de mots :</strong> {wordForProjects[index] || 0}/{maxWordCount}
                                                                                </div>
                                                                            </Form.Group>

                                                                            {/* Modal pour afficher les mots-clés ou sous-mots */}
                                                                            <Modal show={showKeywordModal} onHide={handleCloseKeywordModal}>
                                                                                <Modal.Header>
                                                                                    <h3>Format de la description du projet</h3>
                                                                                </Modal.Header>
                                                                                <Modal.Body>
                                                                                    <h5 className="fw-bold">Objectif:</h5><br />

                                                                                    <h5 className="fw-bold">Rôle:</h5><br />
                                                                                    {Object.keys(keywordData).map((category, idx) => (
                                                                                        <div key={idx} className="ml-3">
                                                                                            {/* Titre de la catégorie */}
                                                                                            <h5>{category} (Mots clés à utiliser)</h5>
                                                                                            {/* Liste des mots-clés sous forme de paragraphes */}
                                                                                            <p className='ml-4'>
                                                                                                {keywordData[category].map((keyword, index) => (
                                                                                                    <span key={index}>
                                                                                                        {keyword}{index < keywordData[category].length - 1 ? " ; " : ""}
                                                                                                    </span>
                                                                                                ))}
                                                                                            </p>
                                                                                        </div>
                                                                                    ))}
                                                                                    <h5 className="fw-bold">Key Deliverables and Outcomes:</h5>
                                                                                </Modal.Body>
                                                                                <Modal.Footer>
                                                                                    <Button variant="success" onClick={handleCloseKeywordModal}>
                                                                                        Fermer
                                                                                    </Button>
                                                                                </Modal.Footer>
                                                                            </Modal>

                                                                            {/* <div className="word-count text-right">
                                                                            <strong>Nombre de mots :</strong> {wordCounts[`wordCount${index}`] || 0}/{maxWordCount}
                                                                        </div> */}
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            <div className="col-lg-6"></div>
                                                                            <div className="col-lg-6 text-right">
                                                                                <Button className='align-items-center justify-center d-flex' variant="success" onClick={Enregistrer}>Enregistrer<FaSave className='ml-1' /> </Button>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </Form>
                                                            </div>
                                                        )}
                                                        {/* <hr className="mt-2 text-success" style={{ borderTop: '1px dashed' }} /> */}
                                                    </div>
                                                ))}
                                                {currentStep === 4 &&
                                                    <div className='btn-large-screen-fab ml-3 mt-2' sx={{ '& > :not(style)': { m: 1 } }}>
                                                        <Button
                                                            className='btn-large-screen-fab btn-success'
                                                            size="small"
                                                            color="primary"
                                                            aria-label="add"
                                                            onClick={addNewProject}
                                                            disabled={!canAddProject}>
                                                            <FaPlus />
                                                        </Button>
                                                    </div>
                                                }
                                                {/* Modale de confirmation */}
                                                <Modal show={showModal} onHide={handleClose}>
                                                    <Modal.Header>
                                                        <Modal.Title>Confirmer la suppression</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>Êtes-vous sûr de vouloir supprimer ce bloc d'expérience ?</Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleClose}>
                                                            Annuler
                                                        </Button>
                                                        <Button variant="success" onClick={confirmDelete}>
                                                            Supprimer
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                {/* {validationMois && !canAddProject && <Alert variant="info" className="mt-3">{validationMois}</Alert>} */}
                                                <div className="d-flex justify-content-start mt-2" style={{ gap: '20px' }}>
                                                    {/* <Button
                                                    variant="success"
                                                    onClick={addNewProject} disabled={!canAddProject}
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '35px',
                                                        height: '35px',
                                                        padding: '0',
                                                        marginTop: '7px',
                                                        // display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontSize: '24px' // Augmentation de la taille du symbole "+"
                                                    }}>
                                                    +
                                                </Button>  */}
                                                    <div className='d-flex text-center align-items-center justify-center'>
                                                        {/* <FaPlusCircle
                                                    variant="success"
                                                    onClick={addNewProject} disabled={!canAddProject}
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '25px',
                                                        height: '25px',
                                                        padding: '0',
                                                        marginTop: '7px',
                                                        // display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontSize: '24px' // Augmentation de la taille du symbole "+"
                                                    }}></FaPlusCircle> <p>Ajouter Projet</p>  */}

                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {currentStep === 5 && (
                                            <>
                                                {/* Étape 1 : Identification */}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Identification</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                <div className="row" style={{ marginBottom: "" }}>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="prenoms">
                                                            <Form.Label style={{ display: 'block' }}> Prénoms<small style={{ display: 'block' }}>Firstname</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="prenoms"
                                                                value={userData.prenoms}
                                                                readOnly
                                                                placeholder="Prénoms"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="nom">
                                                            <Form.Label style={{ display: 'block' }}> Nom <small style={{ display: 'block' }}>Name</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="nom"
                                                                value={userData.nom}
                                                                readOnly
                                                                placeholder="Nom"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                                <div className="row" style={{ marginBottom: "15px" }}>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="email">
                                                            <Form.Label style={{ display: 'block' }}> Email <small style={{ display: 'block' }}>Mail</small></Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={userData.email}
                                                                readOnly
                                                                placeholder="Email"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                                                        <Form.Group controlId="tel">
                                                            <Form.Label style={{ display: 'block' }}> Numéro de téléphone <small style={{ display: 'block' }}>Phone number</small></Form.Label>
                                                            <Form.Control
                                                                type="tel"
                                                                name="tel"
                                                                value={userData.tel}
                                                                readOnly
                                                                placeholder="Téléphone WhatsApp"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>


                                                {/* Étape 2 : Éducation Académique */}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Academic Education/ Éducation académique</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <div className="row">

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="niveau_eleve" className="">
                                                            <Form.Label style={{ display: 'block' }}> Niveau élevé d'éducation<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Highest level of education</small></Form.Label>
                                                            <Form.Control
                                                                name="niveau_eleve"
                                                                value={formData.niveau_eleve}
                                                                readOnly
                                                            >
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="pays" className="">
                                                            <Form.Label style={{ display: 'block' }}> Pays<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Country</small></Form.Label>
                                                            <Form.Control
                                                                name="pays"
                                                                value={formData.pays}
                                                                onChange={handleChange}
                                                                readOnly
                                                                required
                                                            >
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>


                                                    {/* Start Year */}

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="annee_debut_education" className="">
                                                            <Form.Label style={{ display: 'block' }}> Année Début<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Start Year</small></Form.Label>
                                                            <Form.Control
                                                                name="annee_debut_education"
                                                                value={formData.annee_debut_education}
                                                                onChange={handleChange}
                                                                readOnly
                                                            >
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>

                                                    {/* End Year */}
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="annee_fin_education" className="">
                                                            <Form.Label style={{ display: 'block' }}> Année Fin<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>End Year</small></Form.Label>
                                                            <Form.Control
                                                                name="annee_fin_education"
                                                                value={formData.annee_fin_education}
                                                                onChange={handleChange}
                                                                readOnly
                                                            >
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>

                                                </div>
                                                {/* Country, Institution, Field of Study */}
                                                <div className="row">

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="institution" className="">
                                                            <Form.Label style={{ display: 'block' }}> Nom de l'institution<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Name of institution</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="institution"
                                                                value={formData.institution}
                                                                onChange={handleChange}
                                                                readOnly
                                                                placeholder="Entrez le nom de l'institution"
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="filiere" className="">
                                                            <Form.Label style={{ display: 'block' }}> Filière<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Field of study</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="filiere"
                                                                value={formData.filiere}
                                                                onChange={handleChange}
                                                                readOnly
                                                                placeholder="Entrez votre filière"
                                                                required
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>


                                                {/* Étape 3 : Formation Professionnelle */}
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px', }}>Professional Education / Formation Professionelle :</h3>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                <div className="row">
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="lieu_formation" className="">
                                                            <Form.Label style={{ display: 'block' }}> Lieu de formation<small style={{ display: 'block' }}>Provider Name</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lieu_formation"
                                                                value={formData.lieu_formation = lieu}
                                                                onChange={handleChange}
                                                                readOnly
                                                            // placeholder="ATP INOVACT"
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="titre_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Titre du cours<small style={{ display: 'block' }}>Course Title</small></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="titre_cours"
                                                                value={formData.titre_cours = titre}
                                                                onChange={handleChange}
                                                                readOnly
                                                            // placeholder="PMP Preparation Course"
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="date_debut_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Date début<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Start date</small></Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="date_debut_cours"
                                                                value={formData.date_debut_cours}
                                                                onChange={handleChange}
                                                                max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                required
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="date_fin_cours" className="">
                                                            <Form.Label style={{ display: 'block' }}> Date Fin<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>End date</small></Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="date_fin_cours"
                                                                value={formData.date_fin_cours}
                                                                onChange={handleChange}
                                                                max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                required
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-lg-6" style={{ marginBottom: '15px' }}>
                                                        <Form.Group controlId="nombre_heures" className="">
                                                            <Form.Label style={{ display: 'block' }}> Nombre total d'heures<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Qualifying Hours</small></Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="nombre_heures"
                                                                value={formData.nombre_heures}
                                                                onChange={handleChange}
                                                                required
                                                                placeholder="Entrez le total d'heures de cours"
                                                                min="35" // Définit la valeur minimale à 35
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                {/* Étape 4 : Expérience projet */}
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>
                                                        Experience Project / Expérience Projet : {totalMonths} mois
                                                    </h3>
                                                </div>
                                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                                {formDataList.map((formData, index) => (
                                                    <div key={index} id={`project-${index}`}>
                                                        <div className="d-flex mb-1" onClick={() => handleToggle(index)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                            {expanded[index] ? <FaCaretDown style={{ fontSize: '24px' }} /> : <FaCaretRight style={{ fontSize: '24px' }} />}
                                                            <span className="ms-2" style={{ fontSize: '15px' }}> {formData.titre_projet !== "" ? formData.titre_projet : "Nouveau projet"} {datesForProjects[index]} {monthsForProjects && (<span> ({monthsForProjects[index]} mois) </span>)}</span>
                                                        </div>
                                                        {expanded[index] && (
                                                            <div className='mb-3'> <hr className="mt-2 text-muted" style={{ borderTop: '1px solid' }} />
                                                                {errorList[index] && <Alert variant="danger">{errorList[index]}</Alert>}
                                                                <Form>
                                                                    <div className="row">
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`titreprojet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Titre du projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Title</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="titre_projet"
                                                                                    value={formData.titre_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                    readOnly
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`organisation_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Organisation<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Organization</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="organisation"
                                                                                    value={formData.organisation}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                    readOnly
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`poste_occupe_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Poste occupé<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Job Title</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="poste_occupe"
                                                                                    value={formData.poste_occupe}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    required
                                                                                    readOnly
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`domaine_fonctionnel_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Domaine fonctionnel<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Functional Reporting Area</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="domaine_fonctionnel"
                                                                                    value={formData.domaine_fonctionnel}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                >
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`objectif_organisation_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Secteur d'activité<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Organization Primary Focus</small></Form.Label>
                                                                                <Form.Control
                                                                                    name="objectif_organisation"
                                                                                    value={formData.objectif_organisation}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                >
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`approche_methodologique_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Approche méthodologique<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Approach Methodology</small></Form.Label>
                                                                                <Form.Control
                                                                                    name="approche_methodologique"
                                                                                    value={formData.approche_methodologique}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                >
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`taille_equipe_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Taille de l'équipe<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Team Size</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="taille_equipe"
                                                                                    value={formData.taille_equipe}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                >
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`budget_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Budget du projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Budget</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="budget"
                                                                                    value={formData.budget}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                >
                                                                                </Form.Control>
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`date_debut_projet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Date début projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project Start Date</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="date"
                                                                                    name="date_debut_projet"
                                                                                    value={formData.date_debut_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                                    required
                                                                                    readOnly
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-6">
                                                                            <Form.Group controlId={`date_fin_projet_${index}`} className="mb-3">
                                                                                <Form.Label style={{ display: 'block' }}> Date fin projet<span style={{ color: 'red' }}>*</span> <small style={{ display: 'block' }}>Project End Date</small></Form.Label>
                                                                                <Form.Control
                                                                                    type="date"
                                                                                    name="date_fin_projet"
                                                                                    value={formData.date_fin_projet}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    max={new Date().toISOString().split("T")[0]} // Définit la date maximale à aujourd'hui
                                                                                    required
                                                                                    readOnly
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            <Form.Group controlId={`description_0`} className="mb-1 position-relative">
                                                                                {/* <div className=''> */}
                                                                                <Form.Label style={{ display: 'block' }}> Description du projet<span style={{ color: 'red' }}>*</span> / Project Description <small className='' style={{ display: 'block' }}><b>Nb :</b> Le nombre de mot doit etre compris entre 200 et 500.</small> </Form.Label>
                                                                                {/* <small className='' style={{ display: 'block' }}><b>Nb :</b> Le nombre de mot doit etre compris entre 200 et 500.</small> */}
                                                                                {/* </div> */}
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={3}
                                                                                    name="description"
                                                                                    value={formDataList[index].description}
                                                                                    onChange={(e) => handleChangeProjet(index, e)}
                                                                                    readOnly
                                                                                />

                                                                                <Button
                                                                                    variant="success"
                                                                                    className="position-absolute"
                                                                                    style={{ right: "20px", bottom: "25px", zIndex: 1 }}
                                                                                    onClick={handleShowKeywordModal}
                                                                                >
                                                                                    ?
                                                                                </Button>
                                                                                {/* <div className="d-flex justify-content-between mt-2">
                                                                                    <Button
                                                                                        variant="info"
                                                                                        onClick={() => handleChatGPTAnalysis(
                                                                                            formData.description,
                                                                                            {
                                                                                                titre: formData.titre_projet,
                                                                                                poste_occupe: formData.poste_occupe
                                                                                            }
                                                                                        )}
                                                                                        disabled={isAnalysing}
                                                                                    >
                                                                                        {isAnalysing ? (
                                                                                            <>
                                                                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                                                                Analyse en cours...
                                                                                            </>
                                                                                        ) : (
                                                                                            '🔍 Analyser avec ChatGPT'
                                                                                        )}
                                                                                    </Button>
                                                                                </div> */}
                                                                                <div className="word-count text-right">
                                                                                    <strong>Nombre de mots :</strong> {wordForProjects[index] || 0}/{maxWordCount}
                                                                                </div>
                                                                            </Form.Group>
                                                                        </div>
                                                                    </div>
                                                                </Form>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                        {/* Boutons Précédent et Suivant */}
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                {currentStep === 4 && <Button
                                                    variant={canAddProject ? "success" : "default"} // Utilisation d'une couleur différente quand il est désactivé
                                                    onClick={addNewProject}
                                                    className="btn-large-screen" // Ajout de la classe CSS
                                                    disabled={!canAddProject}
                                                    style={{
                                                        borderRadius: '3px',
                                                        width: '100px',
                                                        height: '32px',
                                                        padding: '0',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        backgroundColor: canAddProject ? '' : '', // Couleur grise si désactivé
                                                        cursor: canAddProject ? 'pointer' : 'not-allowed' // Curseur changé quand désactivé
                                                    }}
                                                >
                                                    <FaPlus className='mr-1' />
                                                    Ajouter projet
                                                </Button>}
                                            </div>

                                            <div className='d-flex mt-2 mb-2'>
                                                {/* Bouton "Précédent" seulement si on est à une étape > 1 */}
                                                {currentStep > 1 &&
                                                    <Button variant="success"
                                                        onClick={prevStep} className="mr-2 align-items-center justify-center d-flex"
                                                        disabled={statut === "valide"} // Désactiver si le statut est "Valider"
                                                    >
                                                        <FaArrowCircleLeft className='mr-1' />
                                                        Précédent
                                                    </Button>}

                                                {/* Bouton "Suivant" ou "Soumettre" */}
                                                {currentStep < 5 &&
                                                    <Button className='align-items-center justify-center d-flex'
                                                        variant="success" onClick={nextStep}
                                                        disabled={statut === "valide"} // Désactiver si le statut est "Valider"
                                                    >
                                                        Suivant
                                                        <FaArrowAltCircleRight className='ml-1' />
                                                    </Button>}

                                                {currentStep === 5 &&
                                                    <Button className=' align-items-center justify-center d-flex' variant="success"
                                                        onClick={handleSubmit} type="submit"
                                                        disabled={statut === "valide"} // Désactiver si le statut est "Valider"
                                                    >
                                                        Soumettre
                                                        <FaPaperPlane className='ml-1' />
                                                    </Button>
                                                }
                                            </div>
                                        </div>

                                    </form>
                                </div>
                                {/* Fin Essai */}
                            </div>

                            <div className="col-lg-4 col-md-6 mx-auto col-sm-12 m-4 ">
                                <div className="ibox-content">
                                    <h4 className="text-success" style={{ textTransform: 'uppercase', }}>Commentaires</h4>
                                    <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                    <Commentaire formulaire_id={formulaire_id} user_id={user_id} />
                                </div>
                            </div>

                            {/* Modal pour afficher l'analyse ChatGPT */}
                            <Modal show={showAnalysisModal} onHide={() => setShowAnalysisModal(false)} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>📝 Analyse de la description par ChatGPT</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {chatGPTAnalysis ? (
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{chatGPTAnalysis}</div>
                                    ) : (
                                        <p>Chargement de l'analyse...</p>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowAnalysisModal(false)}>
                                        Fermer
                                    </Button>
                                    <Button variant="success" onClick={() => {
                                        // Optionnel: copier l'analyse dans le presse-papier
                                        navigator.clipboard.writeText(chatGPTAnalysis);
                                        showAlert('Analyse copiée dans le presse-papier !', 'success');
                                    }}>
                                        Copier l'analyse
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>
                </div >
            </div >
        </>
    );
};

export default Eligibilite;
